import { render } from "./ai-grid-virtual-wrapper.vue?vue&type=template&id=0ec585e0"
import script from "./ai-grid-virtual-wrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-grid-virtual-wrapper.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/wrappers/ai-grid-virtual-wrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ec585e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ec585e0', __exports__)) {
    api.reload('0ec585e0', __exports__)
  }
  
  module.hot.accept("./ai-grid-virtual-wrapper.vue?vue&type=template&id=0ec585e0", () => {
    api.rerender('0ec585e0', render)
  })

}


export default __exports__